import { useEffect, useState } from 'react';
import {
  getRecommendations,
  initRecommendations,
  RichRelevancePlacement,
  sendRecommendationsPageData,
  setDepartmentPage,
  setHomepage,
} from '@noths/polaris-client-recommendations';
import { getUserAttributes } from '@noths/polaris-client-user-configuration';
import getConfig from 'next/config';

import { SerializableBlock } from '../../types/Block';
import { NextConfig } from '../../types/NextConfig';
import { PageConfiguration, PageContent, PageMetadata } from '../../types/PageProps';

const { publicRuntimeConfig } = getConfig() as NextConfig;

const getPlacementTypesFromBlocks = (blocks: SerializableBlock[]) =>
  blocks
    .map(({ props }) => props.placementType as string)
    .filter((placementType) => !!placementType);

export interface UseRecommendationsArgs {
  pageContent: PageContent;
  pageConfig: PageConfiguration;
  pageMetadata: PageMetadata;
}

export const useRecommendations = ({
  pageConfig,
  pageContent,
  pageMetadata,
}: UseRecommendationsArgs) => {
  const [placementData, setPlacementData] = useState<RichRelevancePlacement[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (pageMetadata.recommendationsSessionId) {
      getUserAttributes().then(async (attributes) => {
        initRecommendations({
          apiKey: publicRuntimeConfig.RICH_RELEVANCE_API_KEY,
          env: publicRuntimeConfig.NODE_ENV,
          hasDisabledCookies: !pageMetadata.functionalCookiesConsented,
          sessionId: pageMetadata.recommendationsSessionId,
          userId: attributes?.sub,
        });

        if (pageConfig.contentType === 'homepage') {
          setHomepage();
        } else if (pageContent.departmentId) {
          setDepartmentPage(pageContent.departmentId);
        }

        const placementTypes = getPlacementTypesFromBlocks(pageContent.blocks);

        if (placementTypes.length) {
          const placementData = await getRecommendations(placementTypes);
          setPlacementData(placementData);
        } else {
          sendRecommendationsPageData();
        }

        setLoaded(true);
      });
    }
  }, []);

  return {
    getPlacementData: (placementType: string) =>
      placementData.find((pd) => pd.placement_name === placementType) || null,
    loaded,
  };
};
